module.exports = ".tool_button {\r\n  float: right;\r\n  margin-right: 50px;\r\n}\r\n\r\n.support-form {\r\n  min-width: 150px;\r\n  max-width: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.field-width {\r\n  width: 100%;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/support/popup-support.component.css
// module id = ./src/app/support/popup-support.component.css
// module chunks = main